<div class="live-demo-widget">
    <app-widget-header
        [headers]="headers"
        [dashboardId]="dashboardId"
        [widgetId]="id"
        [entitlements]="entitlements"
        [user]="user"
        (updateFilter)="onFilterChanged($event)"
        (headerInit)="onHeaderInitialized()"
        (headerMenuSelect)="onHeaderMenuSelect($event)"
    >
    </app-widget-header>

    <div class="widget-content">
        @if (isErrorOccurred) {
            <div class="no-data" [class.error]="isErrorOccurred">
                <span class="icon-notification-warning" (click)="showErrorMessage()"></span>
            </div>
        }

        @if (shouldDisplayMessage()) {
            <div class="no-data">
                <span>{{ getErrorMessage() }}</span>
            </div>
        }

        <div class="advanced-grid-info-box" [hidden]="!showMessage">
            <h1>
                Configure Group, Pivot &amp; Columns in Tool Panel (<i class="icon-bigw"></i>)
            </h1>
        </div>

        <div #content></div>
    </div>
</div>
